import { Box, Button, Grid, Typography } from '@mui/material';
import React from 'react'
import { forwardRef } from 'react';
import { useImperativeHandle } from 'react';
import { useEffect } from 'react';
import { useState } from 'react';

const API_ENDPOINT = process.env.REACT_APP_API_ENDPOINT;

 // Map labels to local image files
  const imageMap = {
    "IELTS" : "/SAPImages/exams/ielts.png",
    "PTE" : "/SAPImages/exams/pte.png",
    "TOEFL" : "/SAPImages/exams/toefl.png",
    "No Exam" : "/SAPImages/exams/noexam.png",
    "GMAT" : "/SAPImages/exams/gmat.png",
    "GRE" : "/SAPImages/exams/gre.png",
    "SAT": "/SAPImages/exams/sat.png",
    "Other Exams": "/SAPImages/exams/otherexams.png",
  };


function CurrentExamSelection(props, ref) {
    const [testTypes, setTestTypes] = useState([])
    const [selectedTestType, setSelectedTestType] = useState(null)

    useEffect(() => {
           // Fetch menu items using the fetch function
              fetch(`${API_ENDPOINT}testtype`)
                  .then((response) => response.json())
                  .then((data) => {
                      setTestTypes(data);
                  })
                  .catch((error) => {
                      console.error("Error fetching tests:", error);
                  });
                   }, []);

        useImperativeHandle(ref, () => ({
              validate: () => {
                  if (!selectedTestType) {
                  alert("Please select test");
                  return false;
                  }
                  return true;
              },
  
              getData: () => ({
                  prospect_test_type_id: selectedTestType,
              }),
              }));
  return (
    <Box>
      {/* English Exams */}
      <Typography
        sx={{
          fontFamily: "Inter",
          fontWeight: 500,
          fontSize: "22px",
          
          mb: 1,
        }}
      >
        Which exam are you preparing for?
      </Typography>

      <Grid container spacing={2} >
              {testTypes.map((test) => (
                <Grid item xs={12} sm={6} md={4} key={test.id}>
                  <Button
                    fullWidth
                    onClick={() => {
                      setSelectedTestType(test.id)
                     
                    }}
                    sx={{
                      borderRadius: "8px",
                      boxShadow: "0px 0px 10px 0px #0000001A",
                      color: selectedTestType === test.id ? "#fff" : "#000",
                      backgroundColor: selectedTestType === test.id ? "#5E168C" : "#fff",
                      "&:hover": {
                        backgroundColor:
                          selectedTestType === test.id ? "#5E168C" : "#f5f5f5",
                      },
                      textTransform: "none",
                      fontFamily: "Inter",
                      fontSize: "16px",
                      fontWeight: 500,
                      py: 3,
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      gap: 1,
                    }}
                  >
                    <img
                      src={imageMap[test.name] || "/SAPImages/exams/gmat.png" }
                      alt={test.name}
                      style={{ width: "40px", height: "40px", objectFit: "contain" }}
                    />
                    {test.name}
                  </Button>
                </Grid>
              ))}
            </Grid>
        </Box>
  )
}

export default forwardRef(CurrentExamSelection);